import { fromJS } from 'immutable';
import React from 'react';
import { useReframe } from 'nike-re-framejs';

import MiniScoreboardPrematch from './MiniScoreboardPrematch';
import i18n from '@i18n';
import { trackingPropsForSportEvent } from '@/common/tracking';
import { nike1Bet$, nike1SportEvent$ } from '@/nikeone/subs';
import { nike1PrematchEventOptionsInfo$ } from '@/matchOptions/subs';

function ResultsSection({ boxId, boxStore }) {
    const derefSub = useReframe();
    const resultBetsHierarchy = derefSub(['nikeone/box/resultBetsHierarchy', boxStore, boxId]);
    return resultBetsHierarchy
        .map((sportEvent, i) => <ResultMatch key={i} sportEvent={sportEvent} boxStore={boxStore} />)
        .toArray();
}

export default ResultsSection;

function ResultMatch({ sportEvent, boxStore = 'filteredBoxStore' }) {
    const eventId = sportEvent.get('sportEventId');
    const firstBetId = sportEvent.getIn(['betIds', 0]);
    const { derefSub, subscribe } = useReframe();
    const fullSportEvent = derefSub(nike1SportEvent$(boxStore, eventId));
    if (!fullSportEvent) {
        return null;
    }
    const bet = subscribe(nike1Bet$(boxStore, firstBetId));
    if (!bet) {
        return null;
    }
    const result = bet.result;
    if (!result) {
        return null;
    }
    const note = bet.note;
    const header = bet.header;
    const info = derefSub(nike1PrematchEventOptionsInfo$(boxStore, eventId, firstBetId));
    return (
        <div
            data-atid="nikeone-match"
            className="nikeone-match nikeone-match-results"
            {...trackingPropsForSportEvent(fullSportEvent)}
        >
            <MiniScoreboardPrematch
                sportEvent={fullSportEvent}
                betId={firstBetId}
                boxStore={boxStore}
                result={fromJS(result)}
                info={info}
            />
            <div className="market">{header}</div>
            <div>
                {note ? <span className="result">{note} </span> : null}
                {result.scoreToShow ? (
                    <span className="result">
                        {i18n('results.title.result')} : {result.scoreToShow}
                    </span>
                ) : null}
            </div>
        </div>
    );
}
